<template>
  <div>
    <b-tooltip
      :label="normalizedLevel | levelText"
      :type="levelColor(normalizedLevel)"
    >
      <div
        class="masteryLevel"
        :style="{ 'background-color': levelBgColor(normalizedLevel) }"
      >
        <span class="button is-fullwidth" :class="levelColor(normalizedLevel)">
          {{ normalizedLevel | levelTitle }}
        </span>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "MasteryLevel",

  props: ["level"],

  computed: {
    normalizedLevel() {
      if (this.level < 1) return 1;
      if (this.level > 11) return 11;
      return this.level;
    },
  },

  filters: {
    levelText(level) {
      if (level > 10) return "Chess Master";
      return "Level " + level;
    },

    levelTitle(level) {
      return [
        "Super Rookie",
        "Champion Check",
        "Castling Magician",
        "Awesome Thinker",
        "Clever Knight",
        "Strategy Hero",
        "Mega Brain",
        "Cool Professor",
        "Mind Whiz",
        "Chess Genius",
        "Chess Master",
      ][level - 1];
    },
  },

  methods: {
    levelColor(level) {
      return [
        "is-black is-outlined", // "is-warning is-outlined",
        "is-success is-outlined",
        "is-info is-outlined",
        "is-link is-outlined",
        "is-danger is-outlined",
        "is-warning",
        "is-success",
        "is-info",
        "is-link",
        "is-danger",
        "is-black",
      ][level - 1];
    },

    levelBgColor(level) {
      return [
        "whitesmoke",
        "whitesmoke",
        "whitesmoke",
        "whitesmoke",
        "whitesmoke",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
        "transparent",
      ][level - 1];
    },
  },
};
</script>

<style scoped>
.masteryLevel {
  width: 200px;
  border-radius: 4px;
}

.button {
  cursor: default;
  font-size: 0.9em;
}
</style>
